import React, { useEffect, useState, useCallback } from "react";
import FreemodeSlide from "../UI/FreemodeSlide";
import GallerySlide from "../UI/GallerySlide";
import InfoWithImageSection from "../UI/InfoWithImageSection";
import CardModel from "./CardModel";
import styles from "@/styles/mobile/Machine.module.scss";
import MediaQuery from "react-responsive";
import { MachineProps } from "@/app/interface/components";

// Função para verificar se uma imagem existe
const checkImageExists = (url: string) => {
	return new Promise((resolve) => {
		const img = new Image();
		img.onload = () => resolve(true);
		img.onerror = () => resolve(false);
		img.src = url;
	});
};

const MachineMobile: React.FC<MachineProps> = ({ model, modelData }) => {
	const isTablet = MediaQuery({ minWidth: 540 });
	const media = isTablet ? "tablet" : "mobile";
	const [imgs, setImgs] = useState<string[]>([]);

	useEffect(() => {
		const fetchImages = async () => {
			const galleryBasePath = `https://gabcomercio.azureedge.net/azul-agro/${media}/machines/${modelData.machine}/${model}/gallery`;
			const imageUrls = [];
			let index = 1;

			while (true) {
				const imageUrl = `${galleryBasePath}/img-${index}.webp`;
				const exists = await checkImageExists(imageUrl);

				if (!exists) {
					break;
				}

				imageUrls.push(imageUrl);
				index++;
			}

			setImgs(imageUrls);
		};

		fetchImages();
	}, [model, modelData, media]);

	return (
		<main>
			<InfoWithImageSection
				flexDirection="column-reverse"
				isIntro
				title={model
					.replace(/-/g, " ")
					.replace("cana de acucar", "cana-de-açúcar")}
				text={modelData.introSection}
				img={`https://gabcomercio.azureedge.net/azul-agro/${media}/machines/${modelData.machine}/${model}/product.webp`}
				imgHeightFixed
				width={430}
				height={358}
				hasButton
				href={`/contato?machine=${modelData.machine}&model=${model}`}
			/>

			{modelData.about?.[0] && (
				<InfoWithImageSection
					flexDirection="column-reverse"
					justifyContent={"flex-end"}
					isDropdown
					title={`Sobre ${model}`}
					contentDropdown={modelData.about}
					img={`https://gabcomercio.azureedge.net/azul-agro/${media}/machines/${modelData.machine}/${model}/about.webp`}
					imgHeightFixed
					width={430}
					height={430}
					text={""}
					loading={"lazy"}
				/>
			)}

			{modelData.differences?.[0] && (
				<InfoWithImageSection
					justifyContent={"flex-start"}
					isDropdown
					title={"Diferenciais"}
					contentDropdown={modelData.differences}
					img={`https://gabcomercio.azureedge.net/azul-agro/${media}/machines/${modelData.machine}/${model}/difference.webp`}
					imgHeightFixed
					width={430}
					height={430}
					text={""}
					flexDirection="column"
					loading={"lazy"}
				/>
			)}

			<section className={styles.models}>
				<h2 className="h2-medium">Modelos</h2>
				<div>
					<FreemodeSlide gap="16px" padding="0px 16px">
						{modelData.subModels.map((subModel: any, index: number) =>
							subModel.content.map((name: string) => (
								<CardModel
									key={name}
									name={name}
									img={`https://gabcomercio.azureedge.net/azul-agro/${media}/machines/${
										modelData.machine
									}/${model}/models/model-${index + 1}.webp`}
									href={`/${subModel.pdf}`}
								/>
							))
						)}
					</FreemodeSlide>
				</div>
			</section>

			{imgs.length > 0 && (
				<section
					style={{
						overflow: "hidden",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						gap: "24px",
					}}
				>
					<h2 className="h2-medium">Galeria</h2>
					<GallerySlide imgs={imgs} width={430} height={430} />
				</section>
			)}
		</main>
	);
};

export default React.memo(MachineMobile);
